export default {
  tcode: '/tcodeservice',
  auth: '',
}



// WEBPACK FOOTER //
// ./src/utils/service.js